import styled from '@emotion/styled';

export const FormContainer = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
  padding: 10,
}));
